/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as ServerDefs from "./defs.defs.js";

const $nsid = "place.stream.server.upsertStorage";

export { $nsid };

export const $params = /*#__PURE__*/ l.params();

export type $Params = l.InferOutput<typeof $params>;

export const $input = /*#__PURE__*/ l.jsonPayload({"url":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"isActive":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean())});

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>;
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>;

export const $output = /*#__PURE__*/ l.jsonPayload({"storage":/*#__PURE__*/ l.ref<ServerDefs.Storage>((() => ServerDefs.storage) as any)});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Create or update S3 storage configuration for backups. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, ["InvalidUrl","ConnectionFailed","MaskedCredentialsModified"]);

export { main };

export const $lxm = $nsid;
